import React, { useState } from "react";
import { Dropdown } from "antd";
import "./styles.css";
import HexMenu from "../HexMenu";

const HexDropDown = ({
  dropdownComponent,
  clickTrigger,
  menuList,
  onMenuClick,
  MenuComponent,
  componentProps,
  className,
  dropdownClass,
  placement,
  overLayClass,
}) => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    setVisible((prev) => !prev);
  };

  const handleReset = () => {
    componentProps.onReset();
  };

  const handleCancel = () => {
    toggleVisible();
    componentProps?.onCancel();
  };

  const handleSave = (values) => {
    toggleVisible();
    componentProps?.onSave(values);
  };

  const getMenu = () => {
    if (MenuComponent)
      return (
        <MenuComponent
          onSave={handleSave}
          onCancel={handleCancel}
          onReset={handleReset}
          visible={visible}
        />
      );

    return (
      <HexMenu
        menuList={menuList}
        onMenuClick={onMenuClick}
        className={className}
      />
    );
  };

  const dropdownProps = {
    ...(clickTrigger && {
      open: visible,
      trigger: ["click"],
      onOpenChange: toggleVisible,
    }),
  };

  return (
    <Dropdown
      arrow
      overlay={getMenu()}
      placement={`${placement ? placement : "bottom"}`}
      overlayClassName={`hex-dropdown ${overLayClass || ""}`}
      className={`w-fit-content ${dropdownClass || ""}`}
      {...dropdownProps}
    >
      <div>{dropdownComponent}</div>
    </Dropdown>
  );
};
export default HexDropDown;
